export interface IFormHeaderInfo {
  formType: string;
  formName: string;
  typeName: string;
  formPurpose: string;
}


export class FormHeaderInfo implements IFormHeaderInfo {
  private _formType: string;
  private _formName: string;
  private _typeName: string;
  private _formPurpose: string;

  constructor(formType: string, formName: string, typeName: string, formPurpose: string) {
    this._formType = formType;
    this._formName = formName;
    this._typeName = typeName;
    this._formPurpose = formPurpose;
  }

  get formType() {
    return this._formType;
  }

  get formName() {
    return this._formName;
  }

  get typeName() {
    return this._typeName;
  }

  get formPurpose() {
    return this._formPurpose;
  }
}
